module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    class: {
      'schedule-box ma-2': true, 'done': _vm.value.status === 2, 'canceled': _vm.value.status === 1, 'scheduled': _vm.value.status === 0, 'outDated': _vm.value.status === 5
    }
  }, [_c('v-layout', {
    staticClass: "schedule-box-title",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "schedule-conodminium-name",
    attrs: {
      "xs10": "",
      "pt-2": "",
      "mt-2": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.value.condominium.name))])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "control-number",
    on: {
      "click": function($event) {
        return _vm.selectSchedule(_vm.value.id)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.value.controlNumber) + "\n      ")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "pa-2": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "schedule-conodminium-name",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "ellipsis"
  }, [_vm._v("\n        " + _vm._s(_vm.value.condominium.address) + ", " + _vm._s(_vm.value.condominium.addressNumber) + " - " + _vm._s(_vm.value.condominium.neighborhood) + ", " + _vm._s(_vm.value.condominium.city) + " - " + _vm._s(_vm.value.condominium.state) + ", " + _vm._s(_vm.value.condominium.zipCode) + "\n      ")]), _vm._v(" "), _c('div', {}, [_vm._v("\n        Administradora: " + _vm._s(_vm.value.condominium.administrator) + "\n      ")]), _vm._v(" "), _c('div', {}, [_c('strong', [_vm._v("\n          Agendamento: "), (_vm.value.dates.length > 1) ? _c('span', [_vm._v("Inicio: " + _vm._s(_vm._f("formatDate")(_vm.value.dates[0])) + " Fim: " + _vm._s(_vm._f("formatDate")(_vm.value.dates[_vm.value.dates.length - 1])))]) : _c('span', [_vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.value.dates[0])) + " ")])])])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "schedule-footer",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "pt-0": "",
      "pb-0": "",
      "md2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": "",
      "flat": "",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("home")]), _vm._v("\n        " + _vm._s(_vm.value.unitCount) + "\n      ")], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pt-0": "",
      "pb-0": "",
      "md2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": "",
      "flat": "",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("email")]), _vm._v("\n        " + _vm._s(_vm.value.sent ? _vm.value.condominiumsCount + _vm.value.sindicatesCount : "0") + "\n      ")], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pt-0": "",
      "pb-0": "",
      "md2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.hasOrders,
      "flat": "",
      "icon": "",
      "color": "deep-purple lighten-1"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showOrders(_vm.value.id)
      }
    }
  }, [_c('v-icon', [_vm._v("room_service")]), _vm._v("\n        " + _vm._s(_vm.value.ordersCount) + "\n      ")], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "pt-0": "",
      "pb-0": "",
      "md6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "flat": "",
      "color": "red lighten-1"
    },
    on: {
      "click": function($event) {
        return _vm.selectSchedule(_vm.value.id)
      }
    }
  }, [_vm._v("\n        + Detalhes\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c6a929f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/agendamento/Schedule.vue
// module id = 429
// module chunks = 12 13 14 15